import {
  useState
} from "react";


import useMedia
from "../../hooks/useMedia";
import ConfirmDialog from "../common/confirm/ConfirmDialog";
import useToast from "../common/toast/useToast";
import MediaPreviewDialog from "../dialogs/MediaPreviewDialog";
import { Blocks, DownloadCloud, Trash2, View } from "lucide-react";

export default function MediaActions({

  media,
    onDetails,

    setDeleteOpen,

  onRefresh,onSelect,handlePreview,setMedia,setPreviewUrl,setPreviewOpen

}) {

  const {

    getMediaUrl,

    deleteMedia

  } = useMedia();
  const [

    loading,

    setLoading

  ] = useState(false);

const toast =
    useToast();

 
async function handlePreview(){


    setPreviewUrl(
        media.previewUrl

    );

    setPreviewOpen(
        true
    );

}

  async function handleDownload(){

    try{

      setLoading(true);

      const result =
        await getMediaUrl(
          media.id
        );

      if(result?.url){

        const a =
          document.createElement("a");

        a.href =
          result.url;

        a.download =
          media.original_name;

        a.click();

      }

    }finally{

      setLoading(false);

    }

  }


  return(

    <div className="media-actions-footer">
      
                                                {onSelect?<button

                                                    className="btn btn-primary"

                                                    onClick={() =>
                                                        onSelect?.(media)
                                                    }

                                                >

                                                    Select

                                                </button>:""}
      <button

        className="action-btn"

        title="View"

        disabled={loading}

        onClick={()=>{setMedia?.(media);handlePreview()}}

      >
 <View size={16} color="#222" />
      </button>

      <button

        className="action-btn"

        title="Download"

        disabled={loading}

        onClick={handleDownload}

      >

       <DownloadCloud size={16} color="#222" />

      </button>
      {onSelect?"":
      <button

        className="action-btn"

        title="Details"

        disabled={loading}

        onClick={()=>{setMedia?.(media);onDetails()}}

      >

        <Blocks size={16} color="#222" />

      </button>}

      <button

        className="action-btn danger"

        title="Delete"

        disabled={loading}

        onClick={()=>{setDeleteOpen(true)}}

      >

        <Trash2 size={16} color="#222" />

      </button>
      
<style>{`.media-actions-footer{

    display:flex;

    align-items:center;

    gap:8px;

}

.action-btn{

    width:38px;

    height:38px;

    border:none;

    border-radius:10px;

    background:#F3F4F6;

    cursor:pointer;

    transition:.2s;

    font-size:16px;

}

.action-btn:hover{

    background:#E5E7EB;

    transform:translateY(-1px);

}

.action-btn:disabled{

    opacity:.5;

    cursor:not-allowed;

}

.action-btn.danger:hover{

    background:#FEE2E2;

}`}</style>
    </div>

  );

}